import {
    createContext,
    useContext,
} from 'react'

export interface ThemeContextType {
    // The effective theme: true if dark, false if light.
    isDark: boolean
    // The current theme mode: auto (follow OS), dark, or light.
    themeMode: 'auto' | 'dark' | 'light'
    // Cycles through the three modes: auto → dark → light → auto.
    toggleTheme: () => void
    // Allows setting a specific mode.
    setThemeMode: (mode: 'auto' | 'dark' | 'light') => void
    // Any additional UI state (e.g., for your videos/ebooks toggle)
    mode: 'videos' | 'ebooks'
    setMode: (mode: 'videos' | 'ebooks') => void
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export const useTheme = () => {
    const context = useContext(ThemeContext)
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider')
    }
    return context
}
